import React, { useState } from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import { useLocation, useNavigate } from "react-router-dom";
import { changePassword } from "../../../../redux/zservices/BasicAPIFunctions";
import { urtoast } from "../../../Layouts/CustomPopup/eventEmitter";
import { notallowspace } from "../../../Common/FewCommonMethods";
import { passwordvalidation } from "../../../Common/commonvalidation";

const validationSchema = Yup.object().shape({
  old_password: Yup.string()
    .required("Current Password is required")
    .min(8, "Password must be at least 8 characters")
    .test(
      "not-only-spaces",
      "Please enter a valid value",
      (value) => !/\s/.test(value),
    ),
  password: passwordvalidation,
  conformpassword: Yup.string()
    .required("Confirm Password is required")
    .oneOf([Yup.ref("password"), null], "Passwords must match")
    .test(
      "not-only-spaces",
      "Please enter a valid value",
      (value) => !/\s/.test(value),
    ),
});

export default function ChangePassword({ formData }) {
  const laung = localStorage.getItem("laung");
  const [lan, setLan] = useState(laung ?? "en");
  const location = useLocation();
  const [showPassword, setShowPassword] = useState(false);
  const [showPassword1, setShowPassword1] = useState(false);
  const [showPassword2, setShowPassword2] = useState(false);
  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };
  const togglePasswordVisibility1 = () => {
    setShowPassword1(!showPassword1);
  };
  const togglePasswordVisibility2 = () => {
    setShowPassword2(!showPassword2);
  };
  const navigate = useNavigate();

  const initialValues = {
    country_code: formData?.country_code,
    mobile_number: formData?.mobile_number,
    old_password: "",
    password: "",
    conformpassword: "",
  };

  const handleSubmit = (values) => {
    const body = {
      ...values,
      country_code: formData?.country_code,
      mobile_number: formData?.mobile_number,
    };
    changePassword(body)
      .then((res) => {
        if (res.data.status) {
          LogoutMethod()
          urtoast(`Password Updated Successfully`, 1);
        } else if (!res.data.status) {
          urtoast(res?.data?.response?.message, 2);
        }
      })
      .catch((e) => {
        urtoast(`error in login with password`, 2);
      });
  };

  const handleNextClick = () => {
    navigate(`/${lan}/forgetpassword/change`)
  }

  const LogoutMethod = () => {
    localStorage.removeItem("urexperttoken");
    localStorage.removeItem("role_type");
    localStorage.removeItem("refresh_token");
    localStorage.removeItem("urlState");
    navigate(`/${lan}/loginwithemail`);
    window.location.reload()
  };

  return (
    <div className="profile-edit">
      <div className="d-flex align-items-center justify-content-between change-password">
        <div >
          <h1>Change password</h1>
          <p>
            Change your password for security reasons or reset if you forget it.
          </p>
        </div>
        <button onClick={handleNextClick} className="buttons background-button">
          Forgot password?
        </button>
      </div>
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
        enableReinitialize
      >
        {({ setFieldValue }) => (
          <Form>
            <div className="profile-form row">
              <div className="col-md-6">
                <h6>Current password</h6>
                <p>Enter your current password</p>
              </div>
              <div className="col-md-6">
                <div className="password-btn">
                  <Field
                    onKeyDown={notallowspace}
                    type={showPassword ? "text" : "password"}
                    name="old_password"
                    className="form-control"
                    placeholder="Enter current password"
                  />
                  <span onClick={togglePasswordVisibility} className="btn">
                    {showPassword ? (
                      <i className="fa-solid fa-eye" aria-hidden="true"></i>
                    ) : (
                      <i className="fa-solid fa-eye-slash"></i>
                    )}
                  </span>
                </div>
                <ErrorMessage
                  name="old_password"
                  component="div"
                  className="error"
                />
              </div>
            </div>
            <br />
            <div className="profile-form row">
              <div className="col-md-6">
                <h6>New password</h6>
                <p>Choose a strong password</p>
              </div>
              <div className="col-md-6">
                <div className="password-btn">
                  <Field
                    onKeyDown={notallowspace}
                    type={showPassword1 ? "text" : "password"}
                    name="password"
                    className="form-control"
                    placeholder="Enter new password"
                  />
                  <span onClick={togglePasswordVisibility1} className="btn">
                    {showPassword1 ? (
                      <i className="fa-solid fa-eye" aria-hidden="true"></i>
                    ) : (
                      <i className="fa-solid fa-eye-slash"></i>
                    )}
                  </span>
                </div>
                <ErrorMessage
                  name="password"
                  component="div"
                  className="error"
                />
              </div>
            </div>
            <br />
            <div className="profile-form row">
              <div className="col-md-6">
                <h6>Confirm new password</h6>
                <p>Repeat new password for confirmation</p>
              </div>
              <div className="col-md-6">
                <div className="password-btn">

                  <Field
                    onKeyDown={notallowspace}
                    type={showPassword2 ? "text" : "password"}
                    name="conformpassword"
                    className="form-control"
                    placeholder="Repeat new password"
                  />
                  <span onClick={togglePasswordVisibility2} className="btn">
                    {showPassword2 ? (
                      <i className="fa-solid fa-eye" aria-hidden="true"></i>
                    ) : (
                      <i className="fa-solid fa-eye-slash"></i>
                    )}
                  </span>
                </div>
                <ErrorMessage
                  name="conformpassword"
                  component="div"
                  className="error"
                />
              </div>
            </div>
            <div className="d-flex justify-content-end mt-3">
              <button type="submit" className="buttons border-button">
                Update password
              </button>
            </div>
          </Form>
        )}
      </Formik>
    </div>
  );
}
